import type {DownloadListItem} from "~/components/download/types";

export default {
    name: "XSQUARE DAC",
    stats: {
        "Version": "5.0.6.1",
        // "File size":  "3 MB",
        "Update": "June 5, 2025"
    },
    descriptionTitle: "",
    description: "",
    buttons: {
        "Download" : "https://xsquare.dev/files/edu/"
    }
} as DownloadListItem
